// 根据不同的域名设置不同的 shopId
var currentDomain = window.location.hostname;

// 测试域名变量
if (currentDomain === 'heychic-test-store.myshopify.com') {
    localStorage.setItem('shopId', '66793275449');
}else {
    localStorage.setItem('shopId', '59363262637');
}

// 域名(现在统一一个)
var heychic_api = '/apps/user-api';


// var shopIdAuth = '66793275449';//测试 
var shopIdAuth = '59363262637';//au
// var shopIdAuth = '79421964578';//us

// 评论上传文件至服务器
// var img_video_upload = 'https://tcdn.heychic.net/comment/';//测试
var img_video_upload = 'https://cdn.heychic.net/comment/';//正式

//graphql相关
// var graphql_api = 'https://heychic-test-store.myshopify.com';//测试
var graphql_api = 'https://heychic-com-au.myshopify.com';//正式

// var graphql_token = '2ec63bf90823df5100681407fc939e77';//测试
var graphql_token = '28b6e01d4304fc12c8b514799e0aa497';//正式


// 退货面单上传文件至服务器
// var img_upload_return = 'https://tcdn.heychic.net/refund/return/';//测试
var img_upload_return = 'https://cdn.heychic.net/refund/return/';//正式

// 获取url的token
function getUrlParameter(name) {
    const urlParamsCont = new URLSearchParams(window.location.search);
    return urlParamsCont.get(name);
}
var urlParams_token = getUrlParameter('hc_token');
var authorization = localStorage.getItem('hc_token') || urlParams_token;


// 删除cookie
function deleteAllCookies() {
    console.log("删除cookie")
    localStorage.clear();
    // 获取所有的 cookie
    const cookies = document.cookie.split(';');

    // 遍历所有的 cookie，并将它们的过期时间设置为过去的日期
    cookies.forEach(cookie => {
        const cookieName = cookie.split('=')[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    });
}

// 价格整数时不要小数,其他保持不变(针对产品价格)
function formatPrice(priceInCents) {
  var priceValue = priceInCents / 100;
  return priceValue % 1 === 0 ? priceValue.toFixed(0) : priceValue.toFixed(2);
}

// 判断是否为整数
function isInteger(num) {
  return num % 1 === 0 ? Number(num).toFixed(0) : Number(num).toFixed(2);
}

// 示例
isInteger(10);    // true
isInteger(10.5);  // false

// 只做：非空 + 无非法字符 + 长度范围,校验手机号
function isLikelyPhone(value) {
  value = value.trim();

  // 只能包含数字、空格、+、()、-
  if (!/^[+\d\s()-]+$/.test(value)) {
    return false;
  }

  const digits = value.replace(/\D/g, '');
  return digits.length >= 5 && digits.length <= 15;
}

// 获取父级(找到data-new-id)元素,切换色块功能
function getParentByProductId(productId) {
  const productDom = document.querySelector(
    `.product-item[data-product-id="${productId}"]`
  );
  if (!productDom) return null;

  const parent = productDom.closest('[data-new-id]');
  if (!parent) return null;

  return parent;
}

// 是否超过24小时
function has24HoursPassed() {
  const last = localStorage.getItem("lastInterceptTime");
  const lastNewIn = localStorage.getItem("lastInterceptTimeNewIn");
  if(getUrlParameter('utm_content') == 'WELCOME BACK'){
    return (Date.now() - Number(lastNewIn)) > 24 * 60 * 60 * 1000;
  }else{
    return !last || (Date.now() - Number(last)) > 24 * 60 * 60 * 1000;
  }
}

// 针对AU ,转为US码
function convertAuToUsSize(size, type) {
  const getCountry = window.Shopify.country;
  if(!size) return size;
  const m = size.match(/^AU\s*(\S+)\s*\|\s*US\s*(\S+)$/i);
  if (!m && getCountry !== 'US') return size;

  if(m){
    const au = m[1];
    const us = m[2];

    if (getCountry === 'US') {
      return type === 2 ? `US ${us}` : us;
    }
    return type === 2 ? `AU ${au}` : au;
  }else{
    const match = size.match(/^AU\s*(\d+)$/i);
    let usSize;
    let nowCountry;

    if (!match) return size;

    const auSize = Number(match[1]);
    if(window.Shopify.country == 'US'){
      usSize = auSize - 4;
      nowCountry = 'US';
    }else{
      usSize = auSize;
      nowCountry = 'AU';
    }

    if(type == 2){
      return `${nowCountry} ${usSize}`;
    }else{
      return `${usSize}`;
    }
  }
  
}

function getCustomerSign(data = {}) {
  let timestamp = Math.floor(new Date().getTime() / 1000);
  let nonce_str = generateUniqueId(); // 生成 16 位随机字符串

  // 处理 data，确保所有值为字符串类型
  let processed_data = {};
  Object.keys(data).forEach(key => {
    processed_data[key] = (data[key] === null || data[key] === undefined) 
                          ? "" 
                          : (typeof data[key] === "object" ? JSON.stringify(data[key]) : String(data[key]));
  });

  // 添加系统参数
  processed_data.timestamp = timestamp;
  processed_data.nonce_str = nonce_str;

  // 按键排序
  let sortedKeys = Object.keys(processed_data).sort();

  // 生成 key=value 形式的字符串
  let time_data_list = sortedKeys.map(key => `${key}=${processed_data[key]}`).join('&');

  // 计算 MD5
  let time_data_md5 = md5(time_data_list);
  let sign_str = md5(time_data_md5 + '45f0b16430a64a3d061e75ff13891e0a'); // 计算签名

  // 赋值 sign
  processed_data.sign = sign_str;

  return processed_data; // 返回带签名的数据
}
// 定义时间格式化方法
function formatUTCToLocal(utcTimeString, format,type) {
  const date = new Date(utcTimeString);
  const year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，所以要加 1
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const hour12 = String(date.getHours() % 12 || 12).padStart(2, "0");
	let allTime = '';//时分秒
  const monthList = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  if (format == "us") {
    monthList.forEach((e, index) => {
      if (index + 1 == month) {
        month = e;
      }
    });
  }

	if(type !== 'review'){
		// review页面不显示时分秒
		if(format == 'us'){
			allTime = `${hour12}:${minutes}:${seconds} ${ampm}`;
		}else{
			allTime = `${hours}:${minutes}:${seconds}`;
		}
	}

  switch (format) {
    case "us":
      return `${month} ${day},${year} ${allTime}`;
    case "au":
      return `${day}/${month}/${year} ${allTime}`;
    default:
      return `${year}-${month}-${day} ${allTime}`;
  }
}

// 获取当前时区
function getCurrentTimeZone() {
    // 获取当前时区与 UTC 的偏移量（单位：分钟）
    var offsetMinutesCoupon = new Date().getTimezoneOffset();
    var offsetHoursCoupon = Math.floor(Math.abs(offsetMinutesCoupon) / 60);
    var signCoupon = offsetMinutesCoupon > 0 ? '-' : '+';

    // 获取时区名称
    var timeZoneNameCoupon = Intl.DateTimeFormat().resolvedOptions().timeZone;

    return {
        offsetHoursCoupon,
        signCoupon,
        timeZoneNameCoupon
    };
}

// 根据时区名称判断地理位置
function getCountryFromTimeZone(timeZoneNameCoupon) {
    if (timeZoneNameCoupon.startsWith('America/') || timeZoneNameCoupon === 'Pacific/Honolulu') {
        return 'us';
    } else if (timeZoneNameCoupon.startsWith('Australia/')) {
        return 'au';
    }
    return 'default';
}

var { timeZoneNameCoupon } = getCurrentTimeZone();
var countryCom = getCountryFromTimeZone(timeZoneNameCoupon);

// 时间转为 November 21, 2025格式
function formatDateToEnglishUTC(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
  return date.toLocaleDateString('en-US', options);
}

// 时间转为 21 November 2025格式
function formatDateToEnglishUTCNew(dateString) {
  const date = new Date(dateString);
  const options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
  const formatted = date.toLocaleDateString('en-GB', options); // 英式格式是 “day month year”
  return formatted.replace(',', ''); // 去掉逗号，得到 “30 October 2025”
}

function formatDateToEnglishUTCNew(dateString, includeTime = false) {
  const date = new Date(dateString);
  
  if (!includeTime) {
    const options = { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' };
    const formatted = date.toLocaleDateString('en-GB', options);
    return formatted.replace(/,/g, '');
  }
  
  // 包含时间
  const options = { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric', 
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
    timeZone: 'UTC'
  };
  let formatted = date.toLocaleString('en-GB', options);
  // 把 am/pm 转成大写
  formatted = formatted.replace(/\b(am|pm)\b/gi, match => match.toUpperCase());
  return formatted.replace(/,/g, '');
}

// 使用
// console.log(formatDateToEnglishUTCNew("2025-10-30T14:30:00Z", true));  


// 时间转为 12.24 2025格式,type为1时，格式为12/24/2025
function formatDateToChange(str,type) {
  const date = new Date(str);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return type == 1 ? `${day}/${month}/${year}` : `${month}.${day} ${year}`;
}

// 时间转为 12.24 2025格式
function formatDateToLine(str) {
  const date = new Date(str);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}.${day} ${year}`;
}

// 判断时间是否过期 2025-10-31T23:59:59+11:00
function isRefundLabelExpired(endTimeString) {
  const nowUTC = new Date(); // 当前时间（内部以 UTC 存储）
  const endTime = new Date(endTimeString); // 自动识别 "+11:00" 时区并换算为 UTC
  return nowUTC > endTime; // true 表示当前UTC时间已超过截止时间
}


var krm_token = localStorage.getItem('krm_token');
// 接口组件
// 默认请求头配置
var defaultHeaders = {
    "Content-Type": "application/json",
    Authorization: window.location.pathname.includes('/krm') ? krm_token : authorization, // 从你的全局变量中获取
    "X-Shop-Id": shopIdAuth, // 从你的全局变量中获取
};

/**
 * 通用请求函数
 * @param {string} url - 请求的 URL
 * @param {string} method - 请求方法 (GET, POST, PUT, DELETE)
 * @param {object} [customHeaders={}] - 自定义请求头
 * @param {object|null} [body=null] - 请求体 (仅适用于 POST/PUT)
 * @returns {Promise<object>} - 返回一个 Promise，解析为 JSON 数据
 */
function fetchRequest(url, method, customHeaders = {}, body = null) {
    const headers = { ...defaultHeaders, ...customHeaders };
    const options = {
        method,
        headers,
    };

    // 仅在 POST/PUT 请求时添加请求体
    if (body && (method === "POST" || method === "PUT")) {
        options.body = JSON.stringify(body);
    }

    return fetch(url, options)
        .then((response) => {
             if (!response.ok) {
                // 只有 401 才清除登录态并跳转
                if (response.status === 401) {
                    if (!window._isRedirecting) {
                        window._isRedirecting = true;
                        deleteAllCookies();
                        if(!krm_token && window.location.pathname.includes('/krm')){
                          window.location.href = "/pages/krm"
                        }else{
                          window.location.href = "/account/logout";
                        }
                    }
                }
                // 404 只打印警告，不跳转，继续抛出错误
                if (response.status === 404) {
                    console.warn(`接口不存在: ${url}`);
                }

                console.error(`请求失败: ${url}`);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // 解析 JSON 数据
        })
        .then((data) => {
            // 判断业务状态码（假设接口返回格式为 { code: 401, msg: '...', data: {} }）
            if (data.code === 401) {
                // 业务层未授权，清除登录态并跳转
                if (!window._isRedirecting) {
                    window._isRedirecting = true;
                    deleteAllCookies();
                    if(!krm_token && window.location.pathname.includes('/krm')){
                      window.location.href = "/pages/krm"
                    }else{
                      window.location.href = "/account/logout";
                    }
                }
                throw new Error(`业务错误: ${data.msg || '未授权'}`);
            }
            
            // 其他业务错误码（可选）
            if (data.code && data.code !== 200) {
                console.warn(`业务错误码: ${data.code}, 消息: ${data.msg}`);
                // 如果不希望抛出错误影响后续，可以只打印警告
                // throw new Error(`业务错误: ${data.msg || '未知错误'}`);
            }
            
            return data; // 返回完整响应数据
        })
        .catch((error) => {
            console.error("Request Error:", error);
            throw error; // 将错误抛出供调用者捕获
        });
}

function getCurrencySymbolAll(currencyCode) {
  const currencySymbols = {
      "USD": "$",
      "EUR": "€",
      "JPY": "¥",
      "GBP": "£",
      "AUD": "$",
      "CAD": "$",
      "CHF": "Fr",
      "CNY": "¥",
      "SEK": "kr",
      "NZD": "$",
      "KRW": "₩",
      "SGD": "$",
      "NOK": "kr",
      "MXN": "$",
      "INR": "₹",
      "RUB": "₽",
      "ZAR": "R",
      "BRL": "R$",
      "TRY": "₺",
      "HKD": "HK$",
      "IDR": "Rp",
      "ISK": "kr",
      "PHP": "₱",
      "DKK": "kr",
      "PLN": "zł",
      "HUF": "Ft",
      "CZK": "Kč",
      "THB": "฿",
      "MYR": "RM",
      "HRK": "kn",
      "RON": "lei",
      "ILS": "₪",
      "CLP": "$",
      "AED": "د.إ",
      "COP": "$",
      "SAR": "﷼",
      "BGN": "лв",
      "PKR": "₨",
      "EGP": "£",
      "DZD": "د.ج",
      "KWD": "د.ك",
      "QAR": "﷼",
      "KES": "KSh",
      "VND": "₫",
      "ARS": "$",
      "TWD": "NT$",
      "BDT": "৳",
      "NPR": "₨",
      "IQD": "ع.د",
      "COP": "COL$",
      "LKR": "Rs",
      "UGX": "USh",
      "GHS": "GH₵",
      "RON": "RON",
      "MAD": "د.م.",
      "UZS": "so'm"
  };

  return currencySymbols[currencyCode] || "Unknown";
}

// 转成Handle
function toHandle(str) {
  return str
    .trim()                     // 去掉前后空格
    .toLowerCase()              // 转小写
    .replace(/\s+/g, '-')       // 空格或连续空格替换为单个 "-"
    .replace(/[^a-z0-9\-]/g, '') // 移除非字母数字和连字符的字符
    .replace(/\-+/g, '-');      // 多个连字符合并为一个
}


/*
  跳转类型判断
  0: 无需跳转
  1: 系列页
  2: 产品详情
  3: pages页
  4: 自定义页
*/
window.hrefContent = function(name,type,report,report_name,jump_data,status) {
  // 仅针对非new in弹窗
  if(status == 'true'){
    closeNewIn();
  }

  if(!name && (type == 3 || type == 4)){
    name = jump_data;
  }
  if(name){
    if(type >= 0){
      let no_report = false; // 需要上报
      if(report == 0){
        no_report = true; // 不需要上报
      }
      switch (type) {
        case 0:
          detail_link = 'javascript:void(0);'
          if(report == 1){
            handleEvent(report_name)
          }
          break;
        case 1:
          detail_link = `/collections/${name}?no_report=${no_report}`;
          break;
        case 2:
          detail_link = `/products/${name}?no_report=${no_report}`;
          break;
        case 3:
          switch (name) {
            case 'index':
              detail_link = `/?no_report=${no_report}`;
              break;
            case 'wish_list':
              detail_link = `/pages/wishlist?no_report=${no_report}`;
              break;
            case 'new_design':
              detail_link = `/pages/new-design?no_report=${no_report}`;
              break;
            case 'store_locator':
              detail_link = `/pages/store-locator?no_report=${no_report}`;
              break;
            default:
              detail_link = `/pages/${name}?no_report=${no_report}`;
          }
          break;
        case 4:
          detail_link = jump_data;
          break;
      }
    }else{
      detail_link = 'javascript:void(0);'
    }
  }else{
    detail_link = 'javascript:void(0);'
  }
  return window.location.href = detail_link;
}


// 针对ios版本，蒙层出现时顶部header对应增加蒙层(安卓系统不需要，仅针对h5)
function addIOSHeaderBg(){
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if(isiOS){
    console.log('ios')
    $('.ios-header-mask').show();
  }
}

function removeIOSHeaderBg(){
  $('.ios-header-mask').hide();
}


// 判断浏览器,动态显示下载app按钮
function isSafari() {
  const ua = navigator.userAgent;
  return /Safari/.test(ua) && 
         !/Chrome|Chromium|Edg|OPR/.test(ua);
}

function isChrome() {
  const ua = navigator.userAgent;
  return /Chrome/.test(ua) && 
         !/Edg|OPR/.test(ua);
}

function checkTimeCountry() {
    // 1. 定义目标日期和时区
    const targetDate = new Date('2026-01-01T00:00:00');
    const targetTimeZone = 'Australia/Sydney'; // 请根据需求调整时区
    
    // 2. 获取当前时间，并转换为目标时区的时间字符串
    const now = new Date();
    // 使用toLocaleString获取目标时区的完整时间字符串
    const currentInTargetTZ = now.toLocaleString('en-US', { timeZone: targetTimeZone });
    const currentDateInTargetTZ = new Date(currentInTargetTZ);
    
    // 3. 比较时间
    return currentDateInTargetTZ >= targetDate
}

async function verifyMXRecord(domain) {
  try {
    // 1. 使用 Google Public DNS 提供的 JSON API
    const url = `https://dns.google/resolve?name=${encodeURIComponent(domain)}&type=MX`;
    const response = await fetch(url);
    const data = await response.json();

    // 2. 检查是否有 MX 记录
    if (data.Answer && data.Answer.length > 0) {
      return true; // 拥有合法的 MX 记录，域名能支持收信
    }
    return false; // 没有 MX 记录，该后缀绝大概率无法收信
  } catch (error) {
    console.warn("DNS查询失败，跳过此步校验防止影响用户正常使用：", error);
    return true; // 降级处理，API 请求失败时默认视作通过，避免误杀
  }
}
